import { getCookie } from '@visa/lib-cookie';
import { REMEMBER_ME } from '../constants/cookie';

/**
 * Utility decode then and return remember_me cookie as object.
 * remember_me cookie is base64 encoded and will have the following structure
 *
 *   Sample decoded remember_me value
 *   {
 *      "it": 1558094400,
 *      "ut": 1561388425,
 *      "ex": 1577199600,
 *      "ji": "PwXvsVFXozTJnqp-zQdc",
 *      "la": {
 *          "lm": "jo***@gmail.com",
 *          "ld": null
 *      },
 *      "fo": [
 *          {
 *              "fm": "ka***@gmail.com",
 *              "fd": null
 *          },
 *          {
 *              "fm": "ca***@outlook.com",
 *              "fd": null
 *          }
 *      ]
 *   }
 *
 * @return {(null|object)} returns the remember_me cookie
 */
export const getDecodedRemembermeCookie = () => {
  const remembermeCookie = getCookie(REMEMBER_ME);

  // return `null` if remember_me cookie is not set
  if (remembermeCookie === undefined) {
    return null;
  }

  let rememberMe = {};

  try {
    // Sample base64 encoded value:
    // eslint-disable-next-line
    // eyJpdCI6MTU1ODA5NDQwMCwidXQiOjE1NjEzODg0MjUsImV4IjoxNTc3MTk5NjAwLCJqaSI6IlB3WHZzVkZYb3pUSm5xcC16UWRjIiwibGEiOnsibG0iOiJqbyoqKkBnbWFpbC5jb20iLCJsZCI6bnVsbH0sImZvIjpbeyJmbSI6ImthKioqQGdtYWlsLmNvbSIsImZkIjpudWxsfSx7ImZtIjoiY2EqKipAb3V0bG9vay5jb20iLCJmZCI6bnVsbH1dfQ==
    rememberMe = remembermeCookie ? JSON.parse(atob(remembermeCookie)) : rememberMe;
  } catch (e) {
    // console.log('Error parsing remember_me ', e); //eslint-disable-line no-console
    return null;
  }

  return rememberMe;
};

/**
 * Utiltiy to return the return the masked email address encoded in the remmeber_me cookie
 *
 * @return {(string)} masked email from remember_me cookie
 */
export const getUsername = () => {
  return getDecodedRemembermeCookie()?.la?.lm ?? '';
};
